module Meevo.Plugins.Egifts {
    'use strict';

    import SortDirection = Meevo.Model.SortDirection;
    import CoSearchType = Meevo.Model.CoSearchType;

    export class PackagesSection extends EgiftsBaseSection {

        public arrayResults: Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;
        
        public request: EgiftPackedgeSection.IPackagesRequest = this.defaultRequest;

        public changedItems: any = {
            packages: []
        };

        public businessType = null;
        public coBusinessTypeList: Array<EgiftPackedgeSection.ICoBusinessTypeList> = this.coBusinessTypeListData;
        public showCOcolumn = this.canShowCO;

        preSave() {
            //fixing request issue
           
        }

        reloadData() {
            if (this.changedItems.packages.length > 0) {
                this.changedItems.packages = [];
                this.getData(true);    
            }
        }

        getData(isNotResetSearchOption?: boolean): void {
            if (!isNotResetSearchOption) {
                this.request.criteria.isAvailableAsEgift = this.businessType = null;
                this.request = this.defaultRequest
            }           

            let request: EgiftPackedgeSection.IPackagesRequest = this.getRequest(),
                url: string = this.baseEndpoint + "/" + this.sectionEndpoint;

            if (!request.criteria.isAvailableAsEgift) {
                request.criteria.isAvailableAsEgift = null;
            }

            //this.busyService.start();
            this.arrayResults = this.getResults(url, this.onGetData.bind(this), true);
            this.arrayResults.initSearch(request);
        }

        onGetData(pageNumber, items) {
            this.busyService.stop();
        }

        saveData(): angular.IPromise<void> {
            this.context.loadingInProgress = true;
            this.changedItems.coSearchType = this.coSearchType;
            return this.egiftsService.updatePackages(this.changedItems)
                .then((data: any) => {
                    this.model = data;
                    this.activate();
                    this.context.setMode(Meevo.Model.MaintenanceFormState.Readonly);
                    this.loggingService.trace(`Updates saved.`);
                    this.reloadData();
                })
                .finally(() => {
                    this.context.loadingInProgress = false;
                    this.context.postUpdate(this.model);
                });
        }

        sort(sortBy: string, sortDirection: SortDirection): void {
            // Sort direction will be reseted to ascending, when click on other header
            // Otherwise, sort direction wil be changed to the opposite
            this.request.sortDirection = this.request.sortBy === sortBy ? +!this.request.sortDirection : SortDirection.Ascending;
            this.request.sortBy = sortBy;

            this.filter();
        }

        filter(): void {
            let request: EgiftPackedgeSection.IPackagesRequest = this.getRequest();
            this.arrayResults.initSearch(request);

            this.showCOcolumn = this.canShowCO;
        }

        saveIsEgift(packageListItem): void {
            let existedPackageItem = _.find(this.changedItems.packages, (item: any) => {
                if (item.packageTypeId === packageListItem.packageTypeId) {
                    item.isAvailableAsEgift = packageListItem.isAvailableAsEgift;
                    item.isAvailableAsEgiftCO = packageListItem.isAvailableAsEgiftCO;
                    item.homeLocationId = packageListItem.homeLocationId;
                    return item;
                }
            });

            if (!existedPackageItem && packageListItem.packageTypeId) {
                this.changedItems.packages.push({
                    entityVersion: packageListItem.entityVersion,
                    isAvailableAsEgift: packageListItem.isAvailableAsEgift,
                    isAvailableAsEgiftCO: packageListItem.isAvailableAsEgiftCO,
                    packageTypeId: packageListItem.packageTypeId,
                    homeLocationId: packageListItem.homeLocationId
                });
            }
            
            //this.egiftsService.saveIsEgift(data).then(() => {});
        }

        rollBackItem(item) {
            item.isAvailableAsEgift = item.isAvailableAsEgiftCO;
            this.saveIsEgift(item);
        }

        getIsShowRollBackCOCheckbox(item) {
            return (item && item.isAvailableAsEgiftCO != item.isAvailableAsEgift) && this.showCOcolumn
                && item.homeLocationId !== this.identityService.locationId;
        }

        clearFilters() {
            this.request.criteria.cOOwned = COBusinessType.All;
            this.getData(false);

            this.showCOcolumn = this.canShowCO;
        }

        getTenantIDs(item: any) {
            return item && item.homeLocationId != this.identityService.locationId;
        }

        private getRequest(): EgiftPackedgeSection.IPackagesRequest {
            let request: EgiftPackedgeSection.IPackagesRequest = angular.copy(this.request);
            if (this.businessType) {
                request.criteria.businessTypeId = this.businessType.id;
            }

            return request;
        }

        get coSearchType(): CoSearchType | null {
            if (this.context.isCommonLocation) {
                return CoSearchType.Location;
            } else if (this.context.isApplicationModeCO()) {
                return CoSearchType.CentralOffice
            }
            return null;
        }

        get sortDirection(): any {
            return SortDirection;
        }

        //get coBusinessTypeEnum(): any {
        //    return COBusinessType;
        //}

        //get isShowCODefault() {
        //    return this.params.coSearchType == this.coBusinessTypeEnum.AllPackages || this.params.coSearchType == this.coBusinessTypeEnum.COPackages;
        //}

        

        get canShowCO(): boolean {
            return this.context.isCommonLocation && this.request.criteria.cOOwned !== COBusinessType.Location;
        }

        ////Pakedges Data////

        get defaultRequest(): EgiftPackedgeSection.IPackagesRequest {
            let mainSection = _.first(this.context.sections);
            const asLocationId = mainSection.model && !(mainSection.model.settings.requireClientToSelectLocation && mainSection.model.settings.selectedLocationWillReceiveFundsFromEgiftSales) ?
                mainSection.model.settings.locationId : undefined;

            return {
                criteria: {
                    isAvailableAsEgift: null,
                    objectState: Model.ObjectStateEnum.Active,
                    businessTypeId: null,
                    maintenanceMode: null,
                    isGlobal: null,
                    coSearchType: this.coSearchType,
                    cOOwned: null
                },
                itemsPerPage: 25,
                sortBy: 'packageDisplayName',
                sortDirection: SortDirection.Ascending,
                asLocationId: asLocationId
            };
        }

        get coBusinessTypeListData(): Array<EgiftPackedgeSection.ICoBusinessTypeList> {
            return [
                {
                    label: 'LABEL_ALL_PACKAGES',
                    value: COBusinessType.All
                }, {
                    label: 'LABEL_CENTRAL_OFFICE_PACKAGES',
                    value: COBusinessType.CentralOffice
                }, {
                    label: 'LABEL_LOCATION_PACKAGES',
                    value: COBusinessType.Location
                },
            ];
        }
    }
}
